import React from 'react';
import { speak, isSpeechSupported } from '../../utils/speak';

const WordHintsPanel = ({ words }) => {
  if (!words || words.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap mb-4 p-3 bg-green-50 rounded-lg border border-green-200">
      <span className="text-xs font-medium text-green-700 whitespace-nowrap">
        Word Hints:
      </span>
      {words.map((word, index) => (
        <span
          key={word.wordId || index}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border bg-green-100 text-green-800 border-green-200 max-w-md break-words"
          style={{ wordBreak: 'break-word' }}
          title={`Blank #${word.blankIndex + 1}`}
        >
          <span className="text-[10px] flex-shrink-0">💡</span>
          <span className="font-medium break-words">{word.word}</span>
          {word.translation?.text && (
            <span className="text-green-600 break-words">({word.translation.text})</span>
          )}
          {isSpeechSupported() && (
            <button
              onClick={() => speak(word.word)}
              className="flex-shrink-0 text-green-600 hover:text-green-800 transition-colors"
              title="Pronounce"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072M12 6a7 7 0 010 12M8 9l3-3v12l-3-3H5a1 1 0 01-1-1v-4a1 1 0 011-1h3z" />
              </svg>
            </button>
          )}
        </span>
      ))}
    </div>
  );
};

export default WordHintsPanel;
